(function(){
  'use strict';
  var root = document.getElementById('igp'); if (!root) return;
  var data = { usd: false, sports: [], products: [] };
  try { data = JSON.parse(document.getElementById('igp-data').textContent); } catch (e) {}
  var byHandle = {}; data.products.forEach(function(p){ byHandle[p.handle] = p; });
  var N = 4;
  var state = { slots: [] };
  for (var i = 0; i < N; i++) state.slots.push({ handle: null, size: null });

  var slotsEl = document.getElementById('igp-slots');
  var atc = document.getElementById('igp-atc'), note = document.getElementById('igp-note');
  var fill = document.getElementById('igp-fill'), count = document.getElementById('igp-count');
  var sticky = document.getElementById('igp-sticky'), stickyCount = document.getElementById('igp-sticky-count'), stickyBtn = document.getElementById('igp-sticky-btn');
  var NOTE = note ? note.textContent : '';

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function has(pr, size){ return pr.variants.some(function(v){ return v.t === size && v.a; }); }
  function variantFor(s){
    if (!s.handle || !s.size) return null;
    var pr = byHandle[s.handle];
    for (var k = 0; k < pr.variants.length; k++) if (pr.variants[k].t === s.size) return pr.variants[k].id;
    return null;
  }
  function doneCount(){ var n = 0; state.slots.forEach(function(s){ if (variantFor(s)) n++; }); return n; }
  function firstMissing(){ for (var i = 0; i < N; i++) if (!variantFor(state.slots[i])) return i; return -1; }

  function render(){
    var html = '';
    for (var i = 0; i < N; i++){
      var s = state.slots[i], free = i === N - 1, label = 'Shirt ' + (i + 1) + (free ? ' · on us' : '');
      if (!s.handle){
        html += '<div class="igp-slot" data-i="' + i + '"><div class="igp-slot-head"><span class="igp-slot-empty" aria-hidden="true">+</span>' +
          '<div class="igp-slot-name"><span class="igp-slot-n">' + label + '</span><span class="igp-slot-t">Any icon' + (free ? '<span class="igp-free">FREE</span>' : '') + '</span></div>' +
          '<button type="button" class="igp-pick" data-pick="' + i + '">Choose</button></div><div class="igp-hint">Pick an icon for shirt ' + (i + 1) + '</div></div>';
        continue;
      }
      var pr = byHandle[s.handle];
      html += '<div class="igp-slot' + (s.size ? ' is-done' : '') + '" data-i="' + i + '"><div class="igp-slot-head"><img class="igp-slot-img" src="' + esc(pr.img) + '" alt="">' +
        '<div class="igp-slot-name"><span class="igp-slot-n">' + label + '</span><span class="igp-slot-t">' + esc(pr.title) + (free ? '<span class="igp-free">FREE</span>' : '') + '</span></div>' +
        '<button type="button" class="igp-pick" data-pick="' + i + '">Change</button></div><div class="igp-sizes">';
      pr.variants.forEach(function(v){
        html += '<button type="button" class="igp-size' + (s.size === v.t ? ' is-on' : '') + '" data-i="' + i + '" data-size="' + esc(v.t) + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
      });
      html += '</div><div class="igp-hint">Pick a size for shirt ' + (i + 1) + '</div></div>';
    }
    slotsEl.innerHTML = html;
    renderBox();
    var n = doneCount(), txt = n + ' of ' + N + ' ready';
    fill.style.width = (n / N * 100) + '%';
    count.textContent = n === N ? 'Box complete' : txt;
    stickyCount.textContent = n === N ? 'Box complete' : txt;
    setComplete(n === N);
    save();
  }

  /* ---- complete state: the builder flips to black, the box is held (picks saved on this device) for 10 minutes ---- */
  var builder = document.getElementById('igp-builder'), hold = document.getElementById('igp-hold'),
      holdT = document.getElementById('igp-hold-t'), holdLine = document.getElementById('igp-hold-line');
  var HOLD_MS = 10 * 60 * 1000, KEY = 'igp-box', holdUntil = 0, holdTimer = null, wasComplete = false;
  function save(){
    try {
      if (!state.slots.some(function(s){ return s.handle; })) { localStorage.removeItem(KEY); return; }
      localStorage.setItem(KEY, JSON.stringify({ v: 1, slots: state.slots, until: holdUntil }));
    } catch (e) {}
  }
  function restore(){
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || d.v !== 1 || !d.until || d.until < Date.now()) return;
      d.slots.slice(0, N).forEach(function(s, i){
        if (s && byHandle[s.handle]) state.slots[i] = { handle: s.handle, size: has(byHandle[s.handle], s.size) ? s.size : null };
      });
      holdUntil = d.until;
    } catch (e) {}
  }
  function tick(){
    var left = Math.max(0, holdUntil - Date.now()), m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
    if (left <= 0){
      clearInterval(holdTimer); holdTimer = null;
      if (holdLine) holdLine.textContent = 'Your picks are still here. Add the box to lock it in.';
      return;
    }
    if (holdT) holdT.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }
  function setComplete(on){
    if (!builder) return;
    builder.classList.toggle('is-complete', on);
    if (hold) hold.hidden = !on;
    if (on && !wasComplete){
      if (!holdUntil || holdUntil < Date.now()) holdUntil = Date.now() + HOLD_MS;
      if (holdLine && !document.getElementById('igp-hold-t')){ holdLine.innerHTML = "We're holding your box for <time id=\"igp-hold-t\">10:00</time>"; }
      holdT = document.getElementById('igp-hold-t');
      tick(); if (!holdTimer) holdTimer = setInterval(tick, 1000);
      builder.classList.remove('is-flip'); void builder.offsetWidth; builder.classList.add('is-flip');
    }
    if (!on && holdTimer){ clearInterval(holdTimer); holdTimer = null; }
    wasComplete = on;
  }

  /* ---- tap the finished box to look inside ---- */
  var zoom = document.getElementById('igp-zoom'), zoomPan = document.getElementById('igp-zoom-pan');
  function openZoom(){
    if (!zoom || !stage || !builder.classList.contains('is-complete')) return;
    var c = stage.cloneNode(true); c.removeAttribute('id'); c.className = 'igp-stage igp-stage--zoom';
    Array.prototype.forEach.call(c.querySelectorAll('[id]'), function(n){ n.removeAttribute('id'); });
    Array.prototype.forEach.call(c.querySelectorAll('.igp-roll'), function(n){ n.classList.remove('is-in'); });
    Array.prototype.forEach.call(c.querySelectorAll('.igp-roll-tex'), function(n){      // sharpen once the larger print has loaded
      var m = /url\(["']?([^"')]+)["']?\)/.exec(n.style.backgroundImage); if (!m) return;
      var hi = m[1].replace(/width=\d+/, 'width=1200'), im = new Image();
      im.onload = function(){ n.style.backgroundImage = 'url(' + hi + ')'; }; im.src = hi;
    });
    var h = c.querySelector('.igp-zoom-hint'); if (h) h.parentNode.removeChild(h);
    zoomPan.innerHTML = ''; zoomPan.appendChild(c);
    zoom.hidden = false; document.documentElement.classList.add('igp-lock');
    requestAnimationFrame(function(){                       // start centred on the shirts
      zoomPan.scrollLeft = (zoomPan.scrollWidth - zoomPan.clientWidth) * 0.42;
      zoomPan.scrollTop = (zoomPan.scrollHeight - zoomPan.clientHeight) * 0.78;
      zoom.classList.add('is-open');
    });
  }
  function closeZoom(){ if (!zoom || zoom.hidden) return; zoom.classList.remove('is-open'); zoom.hidden = true; zoomPan.innerHTML = ''; document.documentElement.classList.remove('igp-lock'); }
  if (zoom){
    zoom.addEventListener('click', function(e){ if (e.target === zoom || e.target.closest('#igp-zoom-x') || e.target === zoomPan) closeZoom(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeZoom(); });
  }

  /* ---- the gift box: each picked shirt drops in as a roll, its print multiplied by real fabric shading ---- */
  var rollsEl = document.getElementById('igp-rolls'), stageCap = document.getElementById('igp-stage-cap'), stage = document.getElementById('igp-stage');
  var ROLLS = data.rolls || [], inBox = [null, null, null, null];
  ROLLS.forEach(function(r){ var im = new Image(); im.decoding = 'async'; im.src = r.src; });   // shapes ready before the first drop
  function big(src){ return String(src || '').replace(/([?&])width=\d+/, '$1width=700'); }
  function renderBox(){
    if (!rollsEl || !ROLLS.length) return;
    var filled = 0;
    for (var i = 0; i < N; i++){
      var s = state.slots[i], cfg = ROLLS[i], el = rollsEl.querySelector('[data-r="' + i + '"]');
      if (!cfg) continue;
      if (!s.handle){
        if (el && !el.classList.contains('is-out')){ el.classList.remove('is-in'); el.classList.add('is-out'); (function(n){ setTimeout(function(){ if (n.parentNode) n.parentNode.removeChild(n); }, 300); })(el); }
        inBox[i] = null; continue;
      }
      filled++;
      var pr = byHandle[s.handle];
      if (el && el.classList.contains('is-out')){ el.parentNode.removeChild(el); el = null; }
      if (!el){
        el = document.createElement('div'); el.className = 'igp-roll is-in'; el.setAttribute('data-r', i);
        el.style.cssText = 'left:' + cfg.x + '%;top:' + cfg.y + '%;width:' + cfg.w + '%;height:' + cfg.h + '%;z-index:' + (i + 1);
        el.innerHTML = '<div class="igp-roll-in" style="-webkit-mask-image:url(' + cfg.src + ');mask-image:url(' + cfg.src + ')">' +
          '<div class="igp-roll-tex" style="--rot:' + (cfg.angle - 90).toFixed(1) + 'deg"></div>' +
          '<div class="igp-roll-shade" style="background-image:url(' + cfg.src + ')"></div></div>';
        rollsEl.appendChild(el);
      }
      if (inBox[i] !== s.handle){
        var tex = el.querySelector('.igp-roll-tex');
        if (inBox[i]){ el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); }
        tex.style.backgroundImage = 'url(' + big(pr.img) + ')';
        inBox[i] = s.handle;
      }
    }
    if (stageCap){
      var ready = doneCount();
      stageCap.classList.toggle('is-full', filled === N);
      stageCap.textContent = filled === 0 ? 'Your box is empty. Pick the first icon.' : filled === N ? (ready === N ? 'Box full. The 4th shirt is free.' : 'Box full. Now pick the sizes.') : filled + ' of ' + N + ' in the box' + (filled === N - 1 ? ' · next one is free' : '');
    }
  }
  if (stage) stage.addEventListener('click', function(){ openZoom(); });
  function showBox(){ if (stage && window.matchMedia('(max-width: 899px)').matches) stage.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---- picker sheet ---- */
  var sheet = document.getElementById('igp-sheet'), grid = document.getElementById('igp-grid'), tabs = document.getElementById('igp-tabs');
  var pickFor = 0, activeSport = (data.sports[0] && data.sports[0].handle) || '';
  function renderTabs(){
    var html = '';
    data.sports.forEach(function(sp){
      if (!data.products.some(function(p){ return p.sport === sp.handle; })) return;
      html += '<button type="button" role="tab" class="igp-tab' + (sp.handle === activeSport ? ' is-on' : '') + '" data-sport="' + esc(sp.handle) + '">' + esc(sp.label) + '</button>';
    });
    tabs.innerHTML = html;
  }
  function renderGrid(){
    var html = '';
    data.products.forEach(function(p){
      if (p.sport !== activeSport) return;
      html += '<button type="button" class="igp-item' + (state.slots[pickFor].handle === p.handle ? ' is-on' : '') + '" data-h="' + esc(p.handle) + '">' +
        (p.low ? '<i>low stock</i>' : '') + '<img src="' + esc(p.img) + '" alt="" decoding="async"><span>' + esc(p.title) + '</span></button>';
    });
    grid.innerHTML = html; grid.scrollTop = 0;
  }
  function openSheet(i){
    pickFor = i;
    var cur = state.slots[i].handle ? byHandle[state.slots[i].handle] : null;
    if (cur) activeSport = cur.sport;
    renderTabs(); renderGrid();
    sheet.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closeSheet(){ sheet.hidden = true; document.body.style.overflow = ''; }
  function choose(i, handle){
    var s = state.slots[i], pr = byHandle[handle]; if (!pr) return;
    s.handle = handle;
    if (s.size && !has(pr, s.size)) s.size = null;
    if (!s.size){                                   // a gift pack is usually one person: reuse the size already chosen
      for (var k = 0; k < N; k++){ var o = state.slots[k]; if (o.size && has(pr, o.size)){ s.size = o.size; break; } }
    }
  }
  sheet.addEventListener('click', function(e){
    if (e.target.closest('[data-close]')){ closeSheet(); return; }
    var tb = e.target.closest('.igp-tab'); if (tb){ activeSport = tb.dataset.sport; renderTabs(); renderGrid(); return; }
    var it = e.target.closest('.igp-item');
    if (it){
      choose(pickFor, it.dataset.h); closeSheet(); render(); showBox();
    }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

  root.addEventListener('click', function(e){
    var sz = e.target.closest('.igp-size');
    if (sz){ if (!sz.disabled){ state.slots[Number(sz.dataset.i)].size = sz.dataset.size; render(); } return; }
    var pk = e.target.closest('[data-pick]'); if (pk){ openSheet(Number(pk.dataset.pick)); return; }
    var pre = e.target.closest('[data-prefill]');
    if (pre){
      var idx = -1;
      for (var i = 0; i < N; i++) if (!state.slots[i].handle){ idx = i; break; }
      if (idx >= 0 && byHandle[pre.dataset.prefill]){ choose(idx, pre.dataset.prefill); render(); setTimeout(showBox, 50); }
    }
  });

  /* ---- add the pack ---- */
  function addPack(){
    var missing = firstMissing();
    slotsEl.querySelectorAll('.igp-slot').forEach(function(x){ x.classList.remove('is-missing'); });
    if (missing >= 0){
      var el = slotsEl.querySelector('.igp-slot[data-i="' + missing + '"]');
      if (el){ el.classList.add('is-missing'); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var map = {}, order = [];
    state.slots.forEach(function(s){
      var vid = variantFor(s), pr = byHandle[s.handle];
      if (!map[vid]){ map[vid] = { id: Number(vid), quantity: 0, pid: pr.pid, title: pr.title, img: pr.img, size: s.size, price: pr.price, compare: pr.compare, url: pr.url }; order.push(vid); }
      map[vid].quantity++;
    });
    var lines = order.map(function(v){ return map[v]; });
    note.classList.remove('is-err'); note.textContent = NOTE;
    var fail = function(err){ note.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.'; note.classList.add('is-err'); };
    atc.classList.add('is-busy');
    var done = function(){ atc.classList.remove('is-busy'); };
    if (window.ICCart && typeof window.ICCart.add === 'function'){
      window.ICCart.add(lines).then(function(){ try { localStorage.removeItem(KEY); } catch (e) {} }, fail).then(done);
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines.map(function(l){ return { id: l.id, quantity: l.quantity }; }) }) })
      .then(function(r){ return r.json(); })
      .then(function(res){ if (res.status) throw new Error(res.description || res.message); window.location.href = '/cart'; })
      .catch(function(err){ fail(err); done(); });
  }
  atc.addEventListener('click', addPack);
  stickyBtn.addEventListener('click', function(){
    if (firstMissing() >= 0) document.getElementById('igp-builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
    addPack();
  });
  if ('IntersectionObserver' in window){
    var hero = root.querySelector('.igp-hero'), fin = root.querySelector('.igp-final'), heroOut = false, finIn = false;
    var paint = function(){ var on = heroOut && !finIn; sticky.classList.toggle('is-show', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    new IntersectionObserver(function(en){ heroOut = !en[0].isIntersecting; paint(); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(function(en){ finIn = en[0].isIntersecting; paint(); }, { threshold: 0.2 }).observe(fin);
  }

  /* ---- size helper ---- */
  (function(){
    var btn = document.getElementById('igp-fit-btn'), panel = document.getElementById('igp-fit-panel');
    var err = document.getElementById('igp-fit-err'), res = document.getElementById('igp-fit-res');
    var hIn = document.getElementById('igp-h'), wIn = document.getElementById('igp-w');
    var hUnit = document.getElementById('igp-h-unit'), wUnit = document.getElementById('igp-w-unit');
    var fit = document.getElementById('igp-fit');
    var hu = data.usd ? 'ft' : 'cm', wu = data.usd ? 'lb' : 'kg';
    var ADULT = [['S', 63], ['M', 75], ['L', 87], ['XL', 99], ['2XL', 113], ['3XL', 127]];
    var KIDS = [['Kids S', 126], ['Kids M', 140]];
    function fmtFt(cm){ var t = Math.round(cm / 2.54); return Math.floor(t / 12) + "'" + (t % 12) + '"'; }
    function cmVal(){
      var v = String(hIn.value || '').trim().replace(/,/g, '.'); if (!v) return 0;
      if (hu === 'cm') return parseFloat(v) || 0;
      var m = v.match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/);
      if (m) return (parseFloat(m[1]) * 12 + parseFloat(m[2])) * 2.54;
      var n = parseFloat(v); if (!n) return 0;
      if (n > 8) return n * 2.54;
      var f = Math.floor(n), frac = Math.round((n - f) * 10);
      return (f * 12 + (frac >= 10 ? 0 : frac)) * 2.54;
    }
    function kgVal(){ var n = parseFloat(String(wIn.value || '').replace(/,/g, '.')); if (!n) return 0; return wu === 'kg' ? n : n * 0.45359; }
    function paint(){
      fit.querySelectorAll('[data-hu]').forEach(function(b){ b.classList.toggle('is-on', b.dataset.hu === hu); });
      fit.querySelectorAll('[data-wu]').forEach(function(b){ b.classList.toggle('is-on', b.dataset.wu === wu); });
      hUnit.textContent = hu; wUnit.textContent = wu;
      hIn.placeholder = hu === 'cm' ? '175' : '5\'9"'; wIn.placeholder = wu === 'kg' ? '72' : '160';
    }
    function recommend(cm, kg){
      if (cm < 152 || (cm < 158 && kg < 45)){
        for (var k = 0; k < KIDS.length; k++) if (cm < KIDS[k][1]) return { size: KIDS[k][0], kids: true };
        return { size: 'Kids L', kids: true };
      }
      var adj = kg + (cm - 175) * 0.3;
      for (var i = 0; i < ADULT.length; i++) if (adj < ADULT[i][1]) return { size: ADULT[i][0] };
      return { size: '4XL' };
    }
    function compute(){
      var cm = cmVal(), kg = kgVal();
      err.classList.remove('is-on');
      if (!(cm >= 90 && cm <= 230) || !(kg >= 20 && kg <= 250)){
        err.textContent = !cm && !kg ? 'Enter a height and a weight.' : !(cm >= 90 && cm <= 230) ? 'Check the height, that does not look right.' : 'Check the weight, that does not look right.';
        err.classList.add('is-on'); res.innerHTML = ''; return;
      }
      var r = recommend(cm, kg);
      res.innerHTML = '<div class="igp-fit-out"><b class="s' + (r.kids ? ' is-kids' : '') + '">' + esc(r.size) + '</b><span class="l">Their size</span>' +
        '<span class="t">Oversized fit, like the photos. Free size exchange if it is off.</span>' +
        '<button type="button" class="igp-fit-use" data-size="' + esc(r.size) + '">Use ' + esc(r.size) + ' for the whole box</button></div>';
    }
    btn.addEventListener('click', function(){ var open = panel.hidden; panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    fit.addEventListener('click', function(e){
      var t = e.target, u = t.closest('[data-hu]'), w = t.closest('[data-wu]');
      if (u && u.dataset.hu !== hu){ var cm = cmVal(); hu = u.dataset.hu; if (cm) hIn.value = hu === 'cm' ? String(Math.round(cm)) : fmtFt(cm); paint(); return; }
      if (w && w.dataset.wu !== wu){ var kg = kgVal(); wu = w.dataset.wu; if (kg) wIn.value = String(Math.round(wu === 'kg' ? kg : kg / 0.45359)); paint(); return; }
      if (t.closest('#igp-fit-go')){ compute(); return; }
      var use = t.closest('.igp-fit-use');
      if (use){
        var size = use.dataset.size;
        state.slots.forEach(function(s){ if (!s.handle || has(byHandle[s.handle], size)) s.size = s.handle ? size : s.size; });
        state.defaultSize = size; render();
        slotsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    fit.addEventListener('keydown', function(e){ if (e.key === 'Enter' && e.target.tagName === 'INPUT'){ e.preventDefault(); compute(); } });
    paint();
  })();

  /* a size picked through the helper also applies to icons chosen afterwards */
  var _choose = choose;
  choose = function(i, handle){
    _choose(i, handle);
    var s = state.slots[i], pr = byHandle[handle];
    if (pr && !s.size && state.defaultSize && has(pr, state.defaultSize)) s.size = state.defaultSize;
  };

  restore();
  render();
})();
